import LocationInfo from  "./location-info"

export default LocationInfo;